<template>
  <div
      :class="`formulate-input-element formulate-input-element--${context.type} iban-wrapper`"
      :data-type="context.type"
  >

    <input
        v-model="context.model"
        type="text"
        v-bind="attributes"
        @blur="context.blurHandler"
        v-on="$listeners"
    >

  </div>
</template>

<script>
import eformHelpers from "@/mixins/eformHelpers";
import { electronicFormatIBAN } from 'ibantools';
import eformElementHelper from "@/mixins/eformElementHelper";

export default {
  mixins: [
    eformHelpers,
    eformElementHelper,
  ],
  data: () => ({

  }),
  props: {
    context: {
      type: Object,
      required: true
    },
  },
  watch: {
    model(newVal) {
      if (!newVal) {
        return;
      }

      // Format to electronic IBAN (no spaces, uppercase)
      const formatted = electronicFormatIBAN(newVal);

      // Store the formatted IBAN back into context.model
      if (formatted !== this.context.model) {
        this.$set(this.context, 'model', formatted);
      }
    }
  },
  computed: {
    model: {
      get() {
        return this.context.model
      },
      set(value) {
        this.$set(this.context, 'model', value)
      }
    },
    attributes () {
      return this.context.attributes || {}
    },
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>